import { DefaultError } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { blobConnectionInitialValue } from 'components/organisms/forms/blob-connection/BlobConnectionForm';
import { useCustomParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteProviderBlobConnection,
  useGetProviderBlobConnection,
} from 'services/providers/blob';
import { onErrorShowToast } from 'utils/service/errorHandler';

const BlobConnection = () => {
  const providerId = useCustomParamId('id', 'settings/provider');
  const salesChannelId = useCustomParamId(
    'salesChannelId',
    `settings/provider/${providerId}`
  );

  const navigate = useNavigate();
  const blobConnection = useGetProviderBlobConnection(
    providerId,
    salesChannelId
  );
  const { t } = useTranslation();

  const removeBlobConnection = useDeleteProviderBlobConnection();

  const onRemove = async (actions: PopupActions) => {
    await removeBlobConnection.mutateAsync(
      { providerId, salesChannelId },
      {
        onError: (error: DefaultError) => {
          actions.close();
          onErrorShowToast(error);
        },
        onSuccess: () => navigate(`/settings/provider/${providerId}`),
      }
    );
  };

  return (
    <Form.BlobConnection
      i18nextPrefix=''
      initialValues={
        blobConnection.data ? blobConnection.data : blobConnectionInitialValue
      }
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: blobConnection.isLoading }}
      backPath={`/settings/provider/${providerId}`}
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate(`/settings/provider/${providerId}`);
          }}>
          <Button.Description description={t('button.back')} />

          <Button.Icon icon={<PiCaretLeftBold />} />
        </Button>
      }
      topbarContent={
        <div className='flex justify-end'>
          {!blobConnection.data?.isPredefined && (
            <Button
              isClear
              onlyIcon
              onClick={() => {
                navigate(
                  `/settings/provider/${providerId}/blob-connection/edit/${salesChannelId}/keys`,
                  {
                    replace: true,
                  }
                );
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}

          {!blobConnection.data?.isPredefined && (
            <MagellanPopups.DeleteWarning onRemove={onRemove} />
          )}
        </div>
      }
    />
  );
};

export default BlobConnection;
